import { render, staticRenderFns } from "./MembershipMeetingsMain.vue?vue&type=template&id=5828f802&scoped=true"
import script from "./MembershipMeetingsMain.vue?vue&type=script&lang=js"
export * from "./MembershipMeetingsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828f802",
  null
  
)

export default component.exports